import { KEY_USER_NAME, DEFAULT_TOKEN_EXPIRE, KEY_ADMIN_USER_TOKEN } from './constants';
import { service } from './utils';

export function getToken(key) {
    var dataStr = localStorage.getItem(key)
    if (dataStr) {
        var dataObj = JSON.parse(dataStr)
        var now = new Date().getTime()
        if (now < dataObj.expire) {
            return dataObj.value;
        }
        else {
            return '';
        }
    } else {
        return ''
    }
}

export function setToken(key, value, expire = DEFAULT_TOKEN_EXPIRE) {
    var today = new Date()
    today.setHours(0, 0, 0, 0)
    var now = today.getTime()
    var data = {
        value: value,
        expire: now + expire
    };

    localStorage.setItem(key, JSON.stringify(data))
}

export function removeToken(key) {
    return localStorage.removeItem(key)
}

export function getUserName() {
    return localStorage.getItem(KEY_USER_NAME)
}

export function setUserName(value) {
    return localStorage.setItem(KEY_USER_NAME, value)
}

export function removeUserName() {
    return localStorage.removeItem(KEY_USER_NAME)
}

export function adminLogin(data) {
    return service({
        method: 'post',
        url: '/login',
        data
    })
}


export function logout() {
    localStorage.removeItem(KEY_USER_NAME)
    localStorage.removeItem(KEY_ADMIN_USER_TOKEN)
    return true
}

export default service